<div>
  <div class="modal-header">
    <h3>Review</h3>
  </div>
  <div class="modal-body">
    <div>
      <div class="panel panel-default" *ngIf="siteMeta | async as m">
        <div class="panel-heading">
          Site <img *ngIf="m.symbol && m.symbol.contentType | isImage" [src]="m.symbol.url"/>
        </div>
        <div class="panel-body">

          <span
            *ngFor="let key of ['display_name', 'streetaddress', 'village', 'location_description', 'parcel_id']">

              <b><span [innerHTML]="m.fields[key].label | toTrusted"></span></b>:
              <app-display-field [value]="site[key]"
                                 [type]="m.fields[key].type"
                                 [choices]="m.fields[key].choices"></app-display-field>
              <br/>
          </span>
          <app-attachments type="siteattachments" [foreignKey]="site.globalid"
                           [disableEditing]="true"></app-attachments>

          <div class="row" style="padding-top:10px;">
            <div class="col-md-12">
              <div id="mapDiv" style="max-height: 400px;">
                <div id="zoomToolbar" class="btn-toolbar">
                  <div class="btn-group">
                    <button id="zoomIn-button" class="btn btn-primary" (click)="zoomIn()">
                      <span class="fa fa-plus"></span>
                    </button>
                    <button id="zoomOut-button" class="btn btn-primary" (click)="zoomOut()">
                      <i class="fa fa-minus"></i>
                    </button>
                    <button id="lock-button" class="btn btn-primary" (click)="toggleMapLock()"
                            ngbTooltip="Map {{mapLocked ? 'locked' : 'unlocked'}} click to {{mapLocked ? 'unlock' : 'lock'}}."
                            container="body">
                      <i *ngIf="mapLocked" class="fa fa-lock"></i>
                      <i *ngIf="!mapLocked" class="fa fa-unlock"></i>
                    </button>
                  </div>
                </div>

                <button id="LayersButton" class="btn btn-primary" placement="left"
                        (click)="isCollapsed = !isCollapsed" ngbTooltip="Click to toggle layer menu"
                        container="body">
                  Layers
                </button>
                <div id="Layers" style="height:725px;" [ngbCollapse]="isCollapsed">
                  <div class="panel panel-default" style="text-align: center">
                    <div class="panel-body" style="text-align: left;">
                      <div id="layerList"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div *ngIf="contactsMeta | async as m">
      <div *ngFor="let item of contacts" class="panel panel-default">
        <div class="panel-heading">
          {{ item.relationship_type | display:m.fields.relationship_type.choices }} Information
        </div>
        <div class="panel-body">
          <div class="col-md-6"
               *ngFor="let key of (item.contact_contact_type === 'individual' ? contactsDisplayFields : organizationDisplayFields)">

            <b><span [innerHTML]="m.fields[key].label | toTrusted"></span></b>:
            <app-display-field [value]="item[key]"
                               [type]="m.fields[key].type"
                               [choices]="m.fields[key].choices"></app-display-field>
            <br/>
          </div>
        </div>
      </div>
    </div>
    <app-summary-panel *ngIf="permitMeta | async as m" [meta]="m"
                       [searchObject]="m.searchObject"></app-summary-panel>

<!--    <div *ngIf="permitMeta | async as m">-->
<!--      <div class="panel panel-default">-->
<!--        <div class="panel-heading">-->
<!--          {{ item.content_type | display:typeChoices}}-->
<!--        </div>-->
<!--        <div class="panel-body">-->
<!--           <span *ngIf="item.content_type === 111">-->
<!--          <app-emissions-chart *ngIf="standbyService.item.tonnage !== undefined"-->
<!--                               [item]="standbyService.item"></app-emissions-chart>-->
<!--          <br/><br/>-->
<!--           </span>-->
<!--          <span *ngFor="let key of permitDisplayFields">-->

<!--                <b><span [innerHTML]="m.fields[key].label | toTrusted"></span></b>:-->
<!--                <app-display-field [value]="permit[key]" [allowLong]="true"-->
<!--                                   [type]="m.fields[key].type"-->
<!--                                   [choices]="m.fields[key].choices"></app-display-field>-->
<!--                <br/>-->
<!--            </span>-->
<!--            <span *ngFor="let key of serviceMeta.subItems">-->
<!--              <app-nested-inline id="{{key}}_inline"-->
<!--                                 *ngIf="key.indexOf('comment') > -1 && permit.globalid !== undefined"-->
<!--                                 [meta]="serviceMeta[key]" [foreignKey]="permit.globalid"-->
<!--                                 [parentItem]="permit"></app-nested-inline>-->
<!--              <app-nested-inline id="contacts_inline"-->
<!--                                 *ngIf="key.indexOf('contacts') > -1 && permit.globalid !== undefined"-->
<!--                                 [meta]="serviceMeta[key]" [foreignKey]="permit.globalid"-->
<!--                                 [parentItem]="permit"></app-nested-inline>-->

<!--              <app-attachments-inline-->
<!--                *ngIf="key.indexOf('attachment') > -1 && permit.globalid !== undefined && serviceMeta.listAttachments"-->
<!--                [type]="serviceMeta[key].type" [foreignKey]="permit.globalid"-->
<!--                [useVerboseName]="serviceMeta[key].use_verbose_name"-->
<!--                [displayFields]="serviceMeta[key].display_fields">-->

<!--              </app-attachments-inline>-->
<!--          </span>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div *ngIf="item.content_type === 111 && generatorsMeta | async as m">-->
<!--      <div *ngFor="let item of generators; let i = index;" class="panel panel-default">-->
<!--        <div class="panel-heading">-->
<!--          <span>Generator #{{ i + 1 }} <img *ngIf="m.symbol && m.symbol.contentType | isImage"-->
<!--                                            [src]="m.symbol.url"/></span>-->
<!--        </div>-->
<!--        <div class="panel-body">-->
<!--          <div class="row">-->
<!--            <div class="col-md-6" *ngFor="let key of get_generator_display_fields(item)">-->

<!--              <b><span [innerHTML]="m.fields[key].label | toTrusted"></span></b>:-->
<!--              <app-display-field [value]="item[key]"-->
<!--                                 [type]="m.fields[key].type"-->
<!--                                 [choices]="m.fields[key].choices"></app-display-field>-->
<!--            </div>-->
<!--          </div>-->
<!--          <app-attachments type="standbygenerator/generators_attachments" [foreignKey]="item.globalid"-->
<!--                           [disableEditing]="true"></app-attachments>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <app-routing-review *ngIf="reviewType === 'approval' && permitMeta | async as m" [foreignKey]="item.record_id"
                        [contentType]="m.content_type" [expandOnLoad]="true"></app-routing-review>
  </div>
  <div class="modal-footer">
    <app-review-buttons *ngIf="reviewType === 'approval'" [recordId]="item.record_id"
                        [modalInstance]="modalInstance"></app-review-buttons>
    <button class="btn btn-primary" *ngIf="reviewType === 'acceptance'"
            (click)="accept(item, modalInstance)" [disabled]="item.fee_balance > 0">Accept</button>
    <button class="btn btn-default" (click)="close()">Close</button>
  </div>
</div>
